import React, { useState } from 'react';
import './../css/auth.scss';
import Logo from './../assets/icons/Berhasil.svg';
import { ClipLoader } from 'react-spinners';
import { useHistory } from 'react-router-dom';

const ConfirmSuccess = () => {
  const history = useHistory();

  const [isReset, setIsReset] = useState(false);


  return (
    <div className="page">
      <div className="main container-fluid">
        <div className="row">
          <div className="col-lg-8 col-md-12 d-flex align-items-start">
            <div className="px-5 pt-5 mt-5">
              <h3 className="mt-3 text-light">Market Auction Price</h3>
              <p className="mt-3 pr-5 text-light">
                Market Auction Price (MAP) adalah aplikasi yang <br></br> menyediakan informasi harga pasaran mobil
                lelang <br></br> terlengkap di Indonesia. Buatlah keputusan yang tepat <br></br> dan menguntungkan,
                karena semua informasi harga <br></br> pasaran mobil yang mau Anda beli atau jual ada disini.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-12 px-5 py-4">
            {!isReset ? (
              <div className="form-group form-forget bg-white rounded py-3 px-4">
                <p className="text-center mt-4">
                  <h4 className="mb-4">Konfirmasi email sukses</h4>
                </p>
                <p className="text-center mt-4">
                  <img className="text-center" width="80" src={Logo} />
                </p>
                <p className="text-center mt-4">
                  Kembali ke halaman login
                  <a
                    className="ml-1"
                    style={{ color: 'green', cursor: 'pointer' }}
                    onClick={() => history.push('/login', { pageChannel: 'Register Confirmation Page' })}
                  >
                    di sini
                  </a>
                </p>
              </div>
            ) : (
              <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                <ClipLoader loading size={100} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmSuccess;
